import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useRelatedDocuments } from '@features/invoices/hooks/useRelatedDocuments'
import type { RelatedDocumentWithLink } from '@features/invoices/types/relatedDocument'

import { useInvoice } from '../../../../../../../contexts/invoiceContext'
import { getInvoiceRelatedDocuments } from '../utils/getInvoiceRelatedDocuments'

export const useInvoiceRelatedDocuments = (): RelatedDocumentWithLink[] => {
  const { t } = useTranslation()
  const { invoice } = useInvoice()

  const relatedDocuments = useMemo(() => getInvoiceRelatedDocuments({ invoice, t }), [invoice, t])

  return useRelatedDocuments(relatedDocuments)
}
